import React from 'react';
import Manage from './Manage'
import {request} from '../helpers/request'
import {t} from '../helpers/translate.js'
let config = require('config');

class Quote extends Manage {

  loadData() {
    this.showLoading();
    $.when(
      request(`${config.default.api}/application/${this.getSource()}/${this.getApplicationId()}`, 'GET', null, this.loadApplicationData.bind(this))
    )
    .done(this.parseForm.bind(this));
    this.showLoading();
  }

  isDataReady() {
    return this.state.applicationLoaded && this.state.parsedForm;
  }

  getFormConfig(){
    return config.default.clients[this.getSource()].configuration_form.quote
  }

  renderReloadButton(){
    return null
  }

  renderModifyButton(){
    return null
  }

  getPageTitle(){
    return t('View Quote')
  }

}

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote.js